interface Side {
    webHost?: string
    endpoints: {
        meta: string
        data: string
    }
}

interface DeployInfo {
    download: Side & {
        webHost: string,
        specialHosts: {
            plaintext: string,
            markdown: string,
        }
    }
    upload: Side & {
        endpoints: { auth: string }
    }
    delete: Side
}

function error(msg: string): never {
    throw new Error(msg)
}

export const DEPLOY_INFO: DeployInfo = {
    download: {
        endpoints: {
            meta: import.meta.env.VITE_META_ENDPOINT || error('META_ENDPOINT is not set'),
            data: import.meta.env.VITE_DATA_ENDPOINT || error('DATA_ENDPOINT is not set'),
        },
        webHost: import.meta.env.VITE_DOWNLOAD_WEBHOST || error('DOWNLOAD_WEBHOST is not set'),
        specialHosts: {
            plaintext: import.meta.env.VITE_PLAINTEXT_WEBHOST || error('PLAINTEXT_WEBHOST is not set'),
            markdown: import.meta.env.VITE_MARKDOWN_WEBHOST || error('MARKDOWN_WEBHOST is not set'),
        },
    },
    upload: {
        endpoints: {
            data: import.meta.env.VITE_UPLOAD_DATA_ENDPOINT || error('UPLOAD_DATA_ENDPOINT is not set'),
            meta: import.meta.env.VITE_UPLOAD_META_ENDPOINT || error('UPLOAD_META_ENDPOINT is not set'),
            auth: import.meta.env.VITE_UPLOAD_AUTH_ENDPOINT || error('UPLOAD_AUTH_ENDPOINT is not set'),
        }
    },
    delete: {
        endpoints: {
            meta: import.meta.env.VITE_DELETE_META_ENDPOINT || error('DELETE_META_ENDPOINT is not set'),
            data: import.meta.env.VITE_DELETE_DATA_ENDPOINT || error('DELETE_DATA_ENDPOINT is not set'),
        }
    },
}